import { default as Messages } from './messages.svelte'
import { default as Form } from './form.svelte'

const Chat = { Messages, Form }
export { Chat }